import React, { useState } from 'react'
import AdminLayout from '../../../layouts/AdminLayout'
import { useGetProfileQuery } from '../hooks/useGetProfileQuery';
import { toast } from 'sonner';
import FullPageError from '../../../shared/components/errors/FullPageError';
import FullPageSpinner from '../../../shared/components/spinner/FullPageSpinner';
import EditProfileDialog from '../components/EditProfileDialog';
import RequireAuth from '../../../auth/middleware/RequireAuth';

const ProfilePage: React.FC = () => {
    const [show, setShow] = useState(false);

    const { data: profile, isError, error, isLoading, isSuccess } = useGetProfileQuery();

    if (isError) {
        toast.error(error?.message || "Failed to load profile data", {
            id: 'profile-error',
        });
    }

    return (
        <AdminLayout>
            {isError && <FullPageError />}
            {isLoading && <FullPageSpinner />}
            {isSuccess && (
                <div className="container-fluid my-4 px-4 rounded">
                    <div className="card shadow-sm rounded-3">
                        <div className="card-body p-4">
                            <div className='d-flex justify-content-between align-items-center mb-4'>
                                <h5 className="card-title fs-2 fw-bold">Profile Information</h5>
                                <RequireAuth requiredRoles={['dev']} requiredPermissions={['update_profile']} asComponent>
                                    <button className="btn btn-primary" onClick={() => setShow(true)}>Edit</button>
                                </RequireAuth>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="mb-3">
                                        <label className="form-label">Name</label>
                                        <div className="form-control bg-light">
                                            {profile.data.name || "N/A"}
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Email</label>
                                        <div className="form-control bg-light">
                                            {profile.data.email || "N/A"}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    {/* <div className="mb-3">
                                        <label className="form-label">Username</label>
                                        <div className="form-control bg-light">
                                            {profile.data.username || "N/A"}
                                        </div>
                                    </div> */}
                                    <div className="mb-3">
                                        <label className="form-label">Phone</label>
                                        <div className="form-control bg-light">
                                            {profile.data.phone || "N/A"}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <RequireAuth requiredRoles={['dev']} requiredPermissions={['update_profile']} asComponent>
                <EditProfileDialog show={show} onClose={() => setShow(false)} />
            </RequireAuth>
        </AdminLayout>
    )
}

export default ProfilePage